import React from 'react'
import { Typography } from '@mui/material'
import { TimelineItemContentBadgeTypeT } from 'components/Timeline/types'
import TimelineBadge from 'redesign/components/molecules/timeline-badge'
import { TIMELINE_BADGE_VARIANTS } from 'redesign/components/molecules/timeline-badge/constants'
import type { TimelineBadgeProps } from 'redesign/components/molecules/timeline-badge/types'
import AbsenceRequestInfo from 'redesign/components/organisms/absence-request-info/absence-request-info'
import { BUTTON_TYPE } from 'redesign/components/templates/task-details-action-buttons/constant'
import type { ResolveActionButtonsProps } from 'redesign/components/templates/task-details-action-buttons/types'
import { getBadgeProps } from 'redesign/components/templates/timeline/get-badge-props'
import type { MessageDrawerProps } from 'redesign/services/timeline-action-button/types'

export const getRejectAbsenceButton = ({
  setMessageDrawerProps,
  t,
  handleButtonAction,
  task,
  timelineItem,
}: ResolveActionButtonsProps) => {
  const rejectBadgeProps: TimelineBadgeProps = getBadgeProps({
    isOffice: false,
    badgeType: TimelineItemContentBadgeTypeT.absenceRequestRejected,
  }) || { variant: TIMELINE_BADGE_VARIANTS.error, text: '' }

  const rejectDrawerProps: Partial<MessageDrawerProps> = {
    headerLabel: <TimelineBadge {...rejectBadgeProps} skipTooltipText />,
    placeholder: t('absenceRequest.reject.comment.placeholder'),
  }
  const rejectButtonProps = {
    label: t('absenceRequest.buttons.reject'),
    testId: 'absence-request_action-reject',
  }

  return {
    onClick: () =>
      setMessageDrawerProps({
        onClick: (commentText: string) => handleButtonAction(BUTTON_TYPE.rejectAbsenceRequest, commentText),
        headerLabel: <Typography variant="subtitle1">{t('label.comment')}</Typography>,
        isRequired: false,
        commentFieldLabel: t('inputLabel.comment'),
        content: <AbsenceRequestInfo task={task} timelineItem={timelineItem} />,
        ...rejectDrawerProps,
      }),
    ...rejectButtonProps,
  }
}
